import React from 'react';

interface Props {
  image_source: string;
  display_name: string;
  color?: string;
  border_color?: string;
  height?: string;
  width?: string;
  margin?: string;
  onClick?: () => void;
}

export default function Badge({
  image_source,
  display_name,
  color = 'var(--global-secondary-lighter-7)',
  border_color = 'var(--global-secondary-lighter-7)',
  height = '0.8rem',
  width = '',
  margin = '.25rem',
  onClick,
}: Props) {
  return (
    <div
      style={{
        background: color,
        borderRadius: '5px',
        borderColor: border_color,
        borderStyle: 'solid',
        borderWidth: '1px',
        bottom: '1rem',
        right: '1rem',
        display: 'flex',
        alignItems: 'center',
        padding: '.25rem',
        margin: margin,
        height: height,
        width: width,
      }}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <img src={image_source} style={{ borderRadius: '50%', width: height, padding: '0 .25rem 0 0' }} />
      <p style={{ margin: '0', lineHeight: '.75rem', fontSize: '.75rem', padding: '0 .25rem 0 0' }}>{display_name}</p>
    </div>
  );
}
